import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints,
  fontFamilies,
  fontSizes,
  lineHeights,
  fontWeights,
  siteMinWidth,
  borderRadiuses,
  palette,
}: Theme) => ({
  root: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: siteMinWidth,
    margin: '0 auto',
    filter: 'brightness(1)', // container for a child with position 'fixed'
    [breakpoints.up('sm')]: {
      flexDirection: 'column-reverse',
      marginBottom: 0,
      zIndex: 'unset',
    },
    [breakpoints.up('xl')]: {
      flexDirection: 'row',
    },
  },
  title: {
    margin: '0 0 16px',
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.lg,
    fontWeight: fontWeights.medium,
    [breakpoints.up('sm')]: {
      marginBottom: 28,
      fontSize: fontSizes.xl,
      lineHeight: 1.3,
    },
  },
  ecpLayerRoot: {
    paddingTop: 28,
    [breakpoints.up('sm')]: {
      padding: '40px 0',
    },
    [breakpoints.up('xl')]: {
      width: '42%',
      maxWidth: 605,
      padding: '48px 0',
    },
  },
  ecpLayerRootCard: {
    position: 'relative',
    zIndex: 1,
    marginTop: -16,
    borderRadius: '16px 16px 0 0',
    background: 'transparent',
    [breakpoints.up('sm')]: {
      background: palette.common.white,
    },
    [breakpoints.up('xl')]: {
      marginTop: 0,
      borderRadius: borderRadiuses.xs,
      background: 'transparent',
    },
  },
  ecpLayerWrapper: {
    padding: '0 16px',
    [breakpoints.up('sm')]: {
      padding: '0 40px',
    },
    [breakpoints.up('xl')]: {
      padding: '0 48px',
    },
  },
  shadowWrapper: {
    boxShadow: '0px 4px 6px -1px rgba(26, 32, 44, 0.1), 0px 2px 4px -1px rgba(26, 32, 44, 0.06)',
    [breakpoints.up('sm')]: {
      boxShadow: 'none',
    },
  },
  mapLayer: {
    height: 'calc(100vh - 68px)',
    width: '100%',
    marginTop: -64,
    [breakpoints.up('sm')]: {
      height: '55vh',
      display: 'flex',
      marginTop: 0,
    },
    [breakpoints.up('xl')]: {
      position: 'sticky',
      top: 0,
      width: '58%',
      flexGrow: 1,
      height: '100vh',
    },
  },
  mapWrapper: {
    height: '100%',
    [breakpoints.up('xl')]: {
      height: '100%',
    },
  },
  mapLayerHidden: {
    display: 'none',
  },
  searchBar: {
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start',
    paddingBottom: 12,
    [breakpoints.up('sm')]: {
      display: 'grid',
      gridColumnGap: 8,
      alignItems: 'start',
      gridTemplateColumns: 'calc(100% - 128px) 120px',
      paddingBottom: 24,
    },
    '& .MuiOutlinedInput-root  .MuiAutocomplete-input': {
      [breakpoints.down('sm')]: {
        padding: '8px 6px',
      },
    },
    '& > .MuiIconButton-root': {
      marginTop: 8,
      [breakpoints.up('sm')]: {
        marginTop: 0,
      },
    },
    '& form': {
      flexBasis: 'calc(100% - 60px)',
      lineHeight: 1.43,
      [breakpoints.up('sm')]: {
        flexBasis: 'unset',
      },
    },
  },
  filterButtonDesktop: {
    display: 'none',
    [breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      borderRadius: borderRadiuses.xs,
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
  },
  sortButtons: {
    width: '100%',
    [breakpoints.up('sm')]: {
      width: 330,
    },
  },
  storesList: {
    minHeight: 'calc(100vh - 175px)',
    [breakpoints.up('sm')]: {
      margin: '-12px 0 0',
      bottom: 0,
    },
    [breakpoints.up('md')]: {
      minHeight: 'unset',
    },
  },
  filterButtonMobile: {
    width: 'fit-content',
    [breakpoints.up('sm')]: {
      display: 'none',
    },
    '& .MuiIconButton-root': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 44,
      height: 44,
      paddingRight: 0,
      backgroundColor: palette.common.white,
      border: `1px solid ${palette.primary.main}`,
      borderRadius: '50%',
    },
  },
  mobileViewButton: {
    position: 'sticky',
    top: 100,
    width: 200,
    zIndex: 1,
    margin: '20px auto 0',
  },
  mobileViewButtonList: {
    top: 20,
  },
  inputRoot: {
    minWidth: 'unset',
    '&.MuiInput-underline:after': {
      borderBottomColor: palette.primary.main,
    },
    '&.MuiOutlinedInput-root': {
      borderRadius: borderRadiuses.md,
      padding: '0 0 0 16px',
      '& fieldset': {
        borderColor: palette.grey['500'],
      },
      '&.Mui-focused fieldset': {
        borderColor: palette.primary.main,
      },
    },
  },
  input: {
    boxSizing: 'border-box',
    height: 43,
    color: palette.text.primary,
    fontFamily: fontFamilies.primary,
    fontSize: fontSizes.sm,
    padding: '12px 0',
    lineHeight: 1,
  },
}));
